import { ConnectionError, ConnectionErrorReason } from "livekit-client";

const readErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  return "";
};

const readErrorName = (error: unknown): string => {
  if (error instanceof Error) return error.name;
  return "";
};

export const isDuplicateLiveKitIdentityError = (error: unknown): boolean => {
  const message = readErrorMessage(error);
  return /duplicate identity/i.test(message);
};

export const isFatalLiveKitConnectError = (error: unknown): boolean => {
  const message = readErrorMessage(error);

  if (/fingerprint does not match/i.test(message)) return true;
  if (/unable to set offer/i.test(message)) return true;
  if (/could not establish pc connection/i.test(message)) return true;
  if (/negotiation timed out/i.test(message)) return true;
  if (/negotiationerror/i.test(message)) return true;
  if (/negotiation disconnected/i.test(message)) return true;
  if (/could not recover connection/i.test(message)) return true;

  return false;
};

/** Errors caused by overlapping connect attempts (React StrictMode, effect re-run). */
export const isStaleLiveKitConnectError = (error: unknown): boolean => {
  if (error instanceof ConnectionError) {
    if (error.reason === ConnectionErrorReason.Cancelled) return true;
    if (error.reason === ConnectionErrorReason.LeaveRequest) return true;
  }

  const name = readErrorName(error);
  const message = readErrorMessage(error);

  if (name === "AbortError") return true;
  if (/cancel/i.test(message)) return true;
  if (/abort/i.test(message)) return true;
  if (/context canceled/i.test(message)) return true;
  if (/request canceled/i.test(message)) return true;

  return false;
};

export const resolveLiveKitConnectErrorMessage = (error: unknown): string => {
  const message = readErrorMessage(error);

  if (/duplicate identity/i.test(message)) {
    return "La sesión de audio se duplicó. Cierra otras pestañas de Flownect e intenta de nuevo.";
  }

  if (/permission/i.test(message) || /notallowed/i.test(message)) {
    return "Activa el micrófono en los permisos del navegador para esta llamada.";
  }

  if (/fingerprint does not match|negotiation timed out|could not establish pc connection/i.test(message)) {
    return "Falló la negociación de audio WebRTC. Cierra la llamada e inténtalo de nuevo.";
  }

  if (/ice|udp|dtls|webrtc|negotiation/i.test(message)) {
    return "No se pudo establecer el audio (red/UDP). Revisa LiveKit en el servidor e intenta de nuevo.";
  }

  return "No se pudo conectar el audio de la llamada. Intenta de nuevo.";
};
